import React, {FC, useEffect, useState} from 'react'
import {PropsProducts} from '../../../pages/products/TypesProducts'
import {CreateProduct} from '../../all-pages'
import GetProducts from '../../functions/get/GetProducts'




const CreateAccountWF: FC = () => {

    const [productsData, setProductsData] = useState<PropsProducts[]>([]);
    const account = "Webformulaires"

    useEffect(() => {

        GetProducts({setProductsData});
    }, []);

    return (
        <>
            {
                productsData.map((product, index) =>
                  (product.name === account)
                    ? (
                      <CreateProduct name={product.name}
                                     description={product.description}
                                     treaty={product.treaty}
                                     key={index}
                      />
                    ) : ""
                )
            }
        </>
    )
}
export {CreateAccountWF}
